import { Tenant } from "components/Login";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useContext } from "react";

export const useIntegration = <T>(integration: string) => {
  const tenantId = useContext(Tenant);
  return useFirestoreDoc<T>(`o/${tenantId}/integrations/${integration}`);
};
